import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RouteAnnouncerService {
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private destroyRef = inject(DestroyRef);

    announcement = '';

    init(): void {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {
            const title = this.getDeepestRouteTitle();
            this.announcement = title || '';
        });
    }

    private getDeepestRouteTitle(): string {
        let route = this.activatedRoute.firstChild;
        while (route?.firstChild) {
            route = route.firstChild;
        }
        return route?.snapshot?.title ?? '';
    }
}
